import React, { useRef, useState, useEffect } from 'react';
import { PenTool } from 'lucide-react';

export default function SignaturePad({ onSave, label }) {
  const canvasRef = useRef(null);
  const [isDrawing, setIsDrawing] = useState(false);
  const [isEmpty, setIsEmpty] = useState(true);

  useEffect(() => {
    const canvas = canvasRef.current;
    const ctx = canvas.getContext('2d');
    ctx.strokeStyle = '#0a2540';
    ctx.lineWidth = 3;
    ctx.lineCap = 'round';
  }, []);

  const startDrawing = (e) => {
    const canvas = canvasRef.current;
    const rect = canvas.getBoundingClientRect();
    const ctx = canvas.getContext('2d');
    const x = (e.clientX || e.touches[0].clientX) - rect.left;
    const y = (e.clientY || e.touches[0].clientY) - rect.top;
    
    ctx.beginPath();
    ctx.moveTo(x, y);
    setIsDrawing(true);
    setIsEmpty(false);
  };

  const draw = (e) => {
    if (!isDrawing) return;
    const canvas = canvasRef.current;
    const rect = canvas.getBoundingClientRect();
    const ctx = canvas.getContext('2d');
    const x = (e.clientX || e.touches[0].clientX) - rect.left;
    const y = (e.clientY || e.touches[0].clientY) - rect.top;
    
    ctx.lineTo(x, y);
    ctx.stroke();
  };

  const endDrawing = () => {
    setIsDrawing(false);
    onSave(canvasRef.current.toDataURL());
  };

  const clear = () => {
    const canvas = canvasRef.current;
    const ctx = canvas.getContext('2d');
    ctx.clearRect(0, 0, canvas.width, canvas.height);
    setIsEmpty(true);
    onSave(null);
  };

  return (
    <div className="space-y-3">
      <div className="flex justify-between items-center px-1">
        <label className="text-xs font-bold text-stripe-slate uppercase tracking-wider">{label}</label>
        <button type="button" onClick={clear} className="text-[10px] font-bold uppercase tracking-wider text-stripe-blue hover:text-stripe-dark transition-colors">Clear Pad</button>
      </div>
      <div className="relative group">
        <canvas
          ref={canvasRef}
          width={400}
          height={180}
          className="w-full bg-stripe-bg rounded-xl border border-stripe-border cursor-crosshair touch-none group-hover:bg-white transition-all shadow-sm"
          onMouseDown={startDrawing}
          onMouseMove={draw}
          onMouseUp={endDrawing}
          onTouchStart={startDrawing}
          onTouchMove={draw}
          onTouchEnd={endDrawing}
        />
        {isEmpty && (
          <div className="absolute inset-0 flex flex-col items-center justify-center pointer-events-none opacity-30">
             <PenTool size={24} className="mb-2 text-stripe-slate" />
             <p className="text-[10px] font-bold uppercase tracking-wider text-stripe-slate">Legal Signature Required</p>
          </div>
        )}
      </div>
    </div>
  );
}
